<template>
  <div class="component-wrapper d-flex flex-column align-center">
    <Breadcrumb
      :breadcrumbItems="breadCrumbItems"
      :hcmcReportDate="currentHcmcReportDate"
      class="breadcrumb mb-8 mt-8"
    />
    <div
      v-for="(item, i) in reportHistory"
      :key="item.reportVersionId + i"
      class="d-flex flex-sm-row flex-column align-center container mb-4"
    >
      <div v-if="item.actionType == 'upload'" class="mr-sm-auto">
        Ανέβασμα αρχείου από {{ item.actionBy }}
        <br />
        {{ new Date(item.actionDate).toLocaleDateString("el") }}
        {{
          padTo2Digits(new Date(item.actionDate).getHours()) +
          ":" +
          padTo2Digits(new Date(item.actionDate).getMinutes())
        }}
      </div>
      <div v-if="item.actionType == 'hcmcsubmit'" class="mr-sm-auto">
        Υποβλήθηκε στην ΕΚ από {{ item.actionBy }}
        <br />
        {{ new Date(item.actionDate).toLocaleDateString("el") }}
        {{
          padTo2Digits(new Date(item.actionDate).getHours()) +
          ":" +
          padTo2Digits(new Date(item.actionDate).getMinutes())
        }}
      </div>
      <div v-if="item.actionType == 'esmasubmit'" class="mr-sm-auto">
        Υποβλήθηκε στην ESMA από {{ item.actionBy }}
        <br />
        {{ new Date(item.actionDate).toLocaleDateString("el") }}
        {{
          padTo2Digits(new Date(item.actionDate).getHours()) +
          ":" +
          padTo2Digits(new Date(item.actionDate).getMinutes())
        }}
      </div>
      <div v-if="item.actionType == 'esmareturn'" class="mr-sm-auto">
        Απόρριψη από ESMA από {{ item.actionBy }}
        <br />
        {{ new Date(item.actionDate).toLocaleDateString("el") }}
        {{
          padTo2Digits(new Date(item.actionDate).getHours()) +
          ":" +
          padTo2Digits(new Date(item.actionDate).getMinutes())
        }}
      </div>
      <div v-if="item.actionType == 'esmaaccept'" class="mr-sm-auto">
        Αποδοχή από ESMA από {{ item.actionBy }}
        <br />
        {{ new Date(item.actionDate).toLocaleDateString("el") }}
        {{
          padTo2Digits(new Date(item.actionDate).getHours()) +
          ":" +
          padTo2Digits(new Date(item.actionDate).getMinutes())
        }}
      </div>

      <v-btn
        class="
          primary
          rounded
          text-sm-body-1
          font-weight-regular
          button
          mr-sm-5
          mb-sm-0 mb-2
        "
        @click="onSave(item.reportVersionId)"
        >Λήψη αρχείου</v-btn
      >
      <v-btn
        v-if="item.actionType != 'esmareturn'"
        class="primary rounded text-sm-body-1 font-weight-regular button"
        @click="onShow(item)"
        >Προβολή αρχείου</v-btn
      >
      <v-btn
        v-else
        class="primary rounded text-sm-body-1 font-weight-regular button"
        >Προβολή απάντησης</v-btn
      >
    </div>

    <div>
      <v-btn
        class="secondary rounded text-sm-body-1 font-weight-regular mt-16"
        :to="`/hcmc/pending/${currentHcmcReport.reportId}/report`"
        >Επιστροφή</v-btn
      >
    </div>
    <v-dialog min-width="auto" v-model="dialog">
      <ShowReport v-if="dialog" />
    </v-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../components/Breadcrumb.vue";
import ShowReport from "../../components/Modals/ShowReport.vue";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  components: {
    Breadcrumb,
    ShowReport,
  },

  async created() {
    try {
      this.breadCrumbItems[1] = {
        text: `Εκκρεμείς Εκθέσεις`,
        disabled: false,
        to: `/hcmc/pending/reports`,
      };

      this.breadCrumbItems[2] = {
        text: `${new Date(
          this.currentHcmcReport.lastUploadedVersionDate
        ).toLocaleDateString("el")}
        
        `,
        disabled: false,
        to: `/hcmc/pending/${this.currentHcmcReport.reportId}/report`,
      };

      this.breadCrumbItems[3] = {
        text: `Ιστορικό ενεργειών`,
        disabled: true,
        to: `/hcmc/pending/${this.currentHcmcReport.reportId}/history`,
      };

      await this.getReportHistory(this.currentHcmcReport.reportId);
    } catch (e) {}
  },

  data() {
    return {
      breadCrumbItems: [
        {
          text: "Αρχική",
          disabled: false,
          to: "hcmc",
        },
      ],
    };
  },

  computed: {
    ...mapState({
      currentHcmcReport: (state) => state.hcmcreports.currentHcmcReport,
      reportHistory: (state) => state.reports.reportHistory,
      savedReport: (state) => state.reports.savedReport,
    }),
    dialog: {
      get() {
        return this.$store.state.dialogs.showReportDialog;
      },
      set(value) {
        return this.updateShowReportDialog(value);
      },
    },
    ...mapGetters(["currentHcmcReportDate"]),
  },

  methods: {
    ...mapMutations(["updateShowReportDialog", "setCurrentHcmcReportVersion"]),
    ...mapActions(["getReportHistory", "getSavedReport"]),

    padTo2Digits(num) {
      return String(num).padStart(2, "0");
    },

    async onSave(id) {
      try {
        await this.getSavedReport(id);

        const filename = this.savedReport.headers["content-disposition"]
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim();

        const url = window.URL.createObjectURL(
          new Blob([this.savedReport.data])
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch {}
    },

    onShow(item) {
      this.setCurrentHcmcReportVersion(item);
      this.updateShowReportDialog(true);
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  width: 250px !important;
}
.container,
.breadcrumb {
  width: 950px;
}

@media only screen and (max-width: 960px) {
  .container,
  .breadcrumb {
    width: 100%;
  }
}
</style>